import { render, staticRenderFns } from "./BlubberPublicComposer.vue?vue&type=template&id=ee91d02e&"
import script from "./BlubberPublicComposer.vue?vue&type=script&lang=js&"
export * from "./BlubberPublicComposer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/moritz/html/v4.6-hsfl/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ee91d02e')) {
      api.createRecord('ee91d02e', component.options)
    } else {
      api.reload('ee91d02e', component.options)
    }
    module.hot.accept("./BlubberPublicComposer.vue?vue&type=template&id=ee91d02e&", function () {
      api.rerender('ee91d02e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/vue/components/BlubberPublicComposer.vue"
export default component.exports